import { computed, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  getAttributeValue,
  productAttributes,
} from 'containers/lib';
import useLocale from 'hooks/useLocale';

export default {
  mounted() {
    // let Script = document.createElement("script");
    // Script.setAttribute("src", "https://login.smoobu.com/js/Settings/BookingToolIframe.js");
    // Script.defer = true;
    //   Script.addEventListener('load', () => {
    //       // eslint-disable-next-line no-undef
    //       smoobuLoad()
    //   })
    // document.head.appendChild(Script);

    // let ScriptSimplyBook = document.createElement("script");
    // ScriptSimplyBook.setAttribute("src", "//widget.simplybook.it/v2/widget/widget.js");
    // ScriptSimplyBook.defer = true;
    // ScriptSimplyBook.addEventListener('load', () => {
    //   // eslint-disable-next-line no-undef
    //   simplybookLoad()
    // });
    // document.head.appendChild(ScriptSimplyBook);
    document.getElementById("simplybookScriptTag")
      .addEventListener('load', () => {
        // eslint-disable-next-line no-undef
        simplybookLoad();

    })
  },
  props: {
    currentVariant: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const expanded = shallowRef([true, false]);
    const { locale } = useLocale();
    const attributes = computed(() => {
      const attributes =
        props.currentVariant.attributesRaw.map(
          ({ name, value }) => [
            name,
            getAttributeValue(value, locale.value),
          ]
        );
      return productAttributes(attributes, locale.value);
    });
    const generalInformations =
      computed(() => {
        const generalInformations = props.currentVariant.attributesRaw.map(
          ({name, value}) => {
            if (name === 'general-information') {
              return value;
            }
          }
        ).filter(element => {
          if (element != null) {
            return element;
          }
        }).flat(2).map(
          ({name, value}) => [
            name,
            getAttributeValue(value, locale.value),
          ]
        );
        return productAttributes(generalInformations, locale.value)
      });
    const simplybook =
      computed(()=>{
        return props.currentVariant.attributesRaw.map(
          ({name, value}) => {
            if (name === 'smoobu-booking') {
              return value;
            }
          }
        ).filter(element => {
          if (element != null) {
            return element;
          }
        })[0]
      })
    const openAccordion = (e) => {
      const contextPanelGroup = window
        .$('.pdp-accord-toggle')
        .parents('.panel-group-pdp');
      const contextPanel = window
        .$(e.target)
        .parents('.panel-default');
      const contextButton = window.$(
        '.accordion-plus',
        contextPanel
      );
      contextButton.toggleClass('accordion-minus');
      // Remove minus class on all other buttons
      contextPanelGroup
        .find('.accordion-plus')
        .not(contextButton)
        .removeClass('accordion-minus');
    };
    const toggle = (index) => {
      const copy = [...expanded.value];
      copy[index] = !copy[index];
      expanded.value = copy;
    };
    return {
      expanded,
      attributes,
      generalInformations,
      simplybook,
      openAccordion,
      toggle,
      t,
    };
  },
};
